import { IAuthor } from "~/utils/interface";
import React from "react";
import { Link } from "@remix-run/react";

const Author = ({ photo, author_id, name, surname }: IAuthor) => {
  return (
    <div className="">
      <div className="relative">
        <img
          className="rounded-full"
          src={`https://static.wromance.com/${photo}`}
          alt={name}
        />
        <div className="flex justify-center text-white text-[16px] leading-[22px] opacity-70">
          <span className="max-w-[60px] max-xl:text-center">
            {name} {surname}
          </span>
        </div>
      </div>
    </div>
  );
};

Author.displayName = "Author";
export default Author;
